import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_9 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-4"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 1,
  class: "ant-col ant-col-xs-8 ant-col-xl-4"
}
const _hoisted_12 = { class: "ant-col ant-col-xs-16 ant-col-xl-5" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"5px","margin-bottom":"5px"}
}, null, -1)
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_24 = { class: "ant-col ant-col-xs-8 ant-col-xl-3" }
const _hoisted_25 = {
  key: 0,
  class: "ant-col ant-col-xs-8 ant-col-xl-3"
}
const _hoisted_26 = { class: "ant-col ant-col-xs-16 ant-col-xl-14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_card = _resolveComponent("card")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_sazonalidade = _resolveComponent("selecionar-sazonalidade")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_nota_fiscal_detalhe_pagamento_centro_custo = _resolveComponent("nota-fiscal-detalhe-pagamento-centro-custo")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_nota_fiscal_detalhe_pagamento_anexo = _resolveComponent("nota-fiscal-detalhe-pagamento-anexo")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 950,
    centered: "",
    "wrap-class-name": _ctx.props.classeCss + ' ' + (_ctx.state.telaMobile ? 'full-modal' : '')
  }, {
    title: _withCtx(() => [
      _createTextVNode("Detalhe de Pagamento")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
        }, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipo de Documento",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_tipo_documento_financeiro, {
                                empresas: [_ctx.props.empresa],
                                codigoSelecionado: _ctx.state.detalhePagamento.codigoTipoDocumentoFinanceiro,
                                "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.detalhePagamento.codigoTipoDocumentoFinanceiro) = $event)),
                                descricaoSelecionado: _ctx.state.detalhePagamento.descricaoTipoDocumentoFinanceiro,
                                "onUpdate:descricaoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.detalhePagamento.descricaoTipoDocumentoFinanceiro) = $event)),
                                disabled: !_ctx.props.editavel
                              }, null, 8, ["empresas", "codigoSelecionado", "descricaoSelecionado", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        (_ctx.props.detalhesPagamento.length <= 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createVNode(_component_a_form_item, {
                                label: "N.Identificação",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.detalhePagamento.numeroTitulo) = $event)),
                                    disabled: !_ctx.props.editavel
                                  }, null, 8, _hoisted_10), [
                                    [_vModelText, _ctx.state.detalhePagamento.numeroTitulo]
                                  ])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.props.detalhesPagamento.length <= 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_a_form_item, {
                                label: "Vencimento",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data, {
                                    dataSelecionada: _ctx.state.detalhePagamento.data,
                                    "onUpdate:dataSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.detalhePagamento.data) = $event)),
                                    disabled: !_ctx.props.editavel
                                  }, null, 8, ["dataSelecionada", "disabled"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                quantidadeCasasDecimais: 2,
                                valor: _ctx.state.detalhePagamento.valorPagamento,
                                "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.detalhePagamento.valorPagamento) = $event)),
                                disabled: !_ctx.props.editavel
                              }, null, 8, ["valor", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_selecionar_conta, {
                            empresas: [_ctx.props.empresa],
                            required: true,
                            codigoSelecionado: _ctx.state.detalhePagamento.codigoConta,
                            "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.detalhePagamento.codigoConta) = $event)),
                            descricaoSelecionado: _ctx.state.detalhePagamento.descricaoConta,
                            "onUpdate:descricaoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.detalhePagamento.descricaoConta) = $event)),
                            disabled: !_ctx.props.editavel
                          }, null, 8, ["empresas", "codigoSelecionado", "descricaoSelecionado", "disabled"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria do Plano de Contas",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria_plano_conta, {
                                empresas: [_ctx.props.empresa],
                                tipoPlanoConta: 1,
                                codigoSelecionado: _ctx.state.detalhePagamento.codigoPlanoContaCategoria,
                                "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.detalhePagamento.codigoPlanoContaCategoria) = $event)),
                                descricaoSelecionado: _ctx.state.detalhePagamento.nomePlanoContaCategoria,
                                "onUpdate:descricaoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.detalhePagamento.nomePlanoContaCategoria) = $event)),
                                disabled: !_ctx.props.editavel
                              }, null, 8, ["empresas", "codigoSelecionado", "descricaoSelecionado", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_a_form_item, {
                            label: "Observações/Descrição",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.detalhePagamento.observacoes) = $event)),
                                disabled: !_ctx.props.editavel
                              }, null, 8, _hoisted_19), [
                                [_vModelText, _ctx.state.detalhePagamento.observacoes]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.state.detalhePagamento.alterado === false && (_ctx.state.detalhePagamento.codigo <= 0 || _ctx.state.detalhePagamento.codigo === undefined))
                    ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.state.repetir,
                            "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.repetir) = $event)),
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.checkRepetir()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Repetir")
                            ]),
                            _: 1
                          }, 8, ["checked"]),
                          (_ctx.state.repetir)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Período",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_sazonalidade, {
                                          valor: _ctx.state.sazonalidade,
                                          "onUpdate:valor": [
                                            _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.sazonalidade) = $event)),
                                            _cache[15] || (_cache[15] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                          ]
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Qtd de Vezes",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "number",
                                          min: "1",
                                          class: "ant-input ss-input-numerico",
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.repeticao) = $event)),
                                          onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                        }, null, 544), [
                                          [_vModelText, _ctx.state.repeticao]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.state.sazonalidade === _ctx.ESazonalidade.customizada)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createVNode(_component_a_form_item, {
                                          label: "Dias do Período",
                                          class: "ss-margin-campos"
                                        }, {
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              min: "1",
                                              class: "ant-input ss-input-numerico",
                                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.sazonalidadeCustomizada) = $event)),
                                              onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                            }, null, 544), [
                                              [_vModelText, _ctx.state.sazonalidadeCustomizada]
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_26, [
                                    (_ctx.UtilitarioGeral.valorValido(_ctx.state.detalhePagamento.data) && _ctx.state.repeticao > 0)
                                      ? (_openBlock(), _createBlock(_component_a_alert, {
                                          key: 0,
                                          description: _ctx.obterMensagemRepeticao(),
                                          type: "info"
                                        }, null, 8, ["description"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.props.detalhesPagamento.length <= 1)
                    ? (_openBlock(), _createBlock(_component_card, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tab_pane, {
                                key: "1",
                                tab: "CENTROS DE CUSTO"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_nota_fiscal_detalhe_pagamento_centro_custo, {
                                    visivel: _ctx.modalBase.computedVisivel,
                                    valor: _ctx.state.detalhePagamento.valorPagamento,
                                    codigoRegistro: _ctx.state.detalhePagamento.codigo,
                                    centrosCusto: _ctx.state.detalhePagamento.centrosCustos,
                                    "onUpdate:centrosCusto": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.detalhePagamento.centrosCustos) = $event)),
                                    editavel: _ctx.props.editavel
                                  }, null, 8, ["visivel", "valor", "codigoRegistro", "centrosCusto", "editavel"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tab_pane, {
                                key: "2",
                                tab: "ANEXOS"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_nota_fiscal_detalhe_pagamento_anexo, {
                                    visivel: _ctx.modalBase.computedVisivel,
                                    codigoRegistro: _ctx.state.detalhePagamento.codigo,
                                    empresa: _ctx.props.empresa,
                                    anexos: _ctx.state.detalhePagamento.anexos,
                                    "onUpdate:anexos": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.detalhePagamento.anexos) = $event)),
                                    editavel: _ctx.props.editavel
                                  }, null, 8, ["visivel", "codigoRegistro", "empresa", "anexos", "editavel"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_ctx.state.mostrarCentroCusto)
                      ? (_openBlock(), _createBlock(_component_card, {
                          key: 2,
                          titulo: "CENTROS DE CUSTOS"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_nota_fiscal_detalhe_pagamento_centro_custo, {
                              visivel: _ctx.modalBase.computedVisivel,
                              valor: _ctx.state.detalhePagamento.valorPagamento,
                              codigoRegistro: _ctx.state.detalhePagamento.codigo,
                              centrosCusto: _ctx.state.detalhePagamento.centrosCustos,
                              "onUpdate:centrosCusto": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.detalhePagamento.centrosCustos) = $event)),
                              editavel: _ctx.props.editavel
                            }, null, 8, ["visivel", "valor", "codigoRegistro", "centrosCusto", "editavel"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}